import { render, staticRenderFns } from "./underconstruction.vue?vue&type=template&id=fac21a68&"
import script from "./underconstruction.vue?vue&type=script&lang=js&"
export * from "./underconstruction.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/underconstruction.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports